import React from 'react';
import styles from './step.module.css';

const Step = (props) => {
  return (
    <p className={styles.step_text}><span>{props.currentStep}</span>/21</p>
  );
}

export { Step };